/*!
 * Coming Soon badge override
 * When a product is tagged 'coming soon' and unavailable, swap "Sold out"
 * labels/buttons to "Coming Soon" — on the product page (body-level flag)
 * and on collection/grid product cards (per-card flag).
 */
(function () {
  function getLabel() {
    var label = (window.theme && typeof window.theme.localize === 'function')
      ? window.theme.localize('COMING_SOON')
      : '';
    return label || 'Coming Soon';
  }

  function swapAddButtonText(scope, label) {
    var addTextEls = scope.querySelectorAll(
      '.js-product-add-text, [name="add"] staged-action-text'
    );
    addTextEls.forEach(function (el) {
      var buttonsContainer = el.closest('.js-product-buttons');
      var isDisabled = buttonsContainer
        ? buttonsContainer.classList.contains('is-disabled')
        : el.closest('[disabled]') !== null;
      if (isDisabled) {
        el.textContent = label;
      }
    });
  }

  function swapBadgeText(scope, label) {
    var badgeTextEls = scope.querySelectorAll(
      '[data-label="sold_out"] .label__text, .label--sold_out .label__text'
    );
    badgeTextEls.forEach(function (el) {
      el.textContent = label;
    });
  }

  function swapCardQuickButton(scope, label) {
    var quickButtons = scope.querySelectorAll('.product-card-btn__btn[disabled]');
    quickButtons.forEach(function (el) {
      el.textContent = label;
    });
  }

  function applyComingSoonLabel() {
    var label = getLabel();

    // Product detail page: single body-level flag
    if (document.body.dataset.comingSoon === 'true') {
      swapAddButtonText(document, label);
      swapBadgeText(document, label);
    }

    // Collection / grid pages: one flag per product-card
    document.querySelectorAll('product-card[data-coming-soon="true"]').forEach(function (card) {
      swapBadgeText(card, label);
      swapCardQuickButton(card, label);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyComingSoonLabel);
  } else {
    applyComingSoonLabel();
  }

  document.addEventListener('variant:changed', applyComingSoonLabel);
})();
